/**
 * Run all counters on the page.
 *
 * @param {string} elementSelector
 * @param {number} seconds
 */
window.Counters = function(elementSelector, seconds) {
    var elements = document.getElementsByClassName(elementSelector);

    /**
     * The counter component, run a single counter.
     *
     * @param {object} element
     */
    var Counter = function(element) {
        var counterData = element.getAttribute('data-counter');
        var steps = counterData / (seconds * 60);
        var progress = 0;
        var maxParts = parseInt(counterData).toString().split('');
        var counterParts = Array(maxParts).fill(0);

        counterParts.forEach(draw);
        createObserver();

        /**
         * Observe the element, start the counter if the element is visible.
         */
        function createObserver() {
            var options = {
                root: null,
                rootMargin: '0px',
                threshold: [0, 1]
            };

            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(handleIntersect, options);
                observer.observe(element);

                return;
            }

            animate();
        }

        /**
         * Start the animation if the element is 100% visible.
         *
         * @param {object} entries
         */
        function handleIntersect(entries) {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio == 1 && progress == 0) {
                    animate();
                }
            });
        }

        /**
         * Draw on the screen frame rate, usually 60fps.
         */
        function animate() {
            progress += steps;

            if (progress < counterData) {
                split();
                if ('requestAnimationFrame' in window) {
                    window.requestAnimationFrame(animate);

                    return;
                }

                window.setTimeout(animate, 20);

                return;
            }

            progress = counterData;
            split();
        }

        /**
         * Split the progress number.
         */
        function split() {
            var parts = parseInt(progress).toString().split('');

            while (parts.length < maxParts.length) {
                parts.unshift(0);
            }

            parts.forEach(draw);
        }

        /**
         * Draw a part of the counter.
         * Only update the parts if the number changed.
         *
         * @param {number} part
         * @param {number} blockIndex
         */
        function draw(part, blockIndex) {
            if (counterParts[blockIndex] != part || progress == 0) {
                counterParts[blockIndex] = part;

                if (element.getElementsByClassName('js-counter-part-' + blockIndex).item(0)) {
                    element.getElementsByClassName('js-counter-part-' + blockIndex).item(0).innerHTML = part;
                }
            }
        }
    };

    for (var element = 0; element < elements.length; element++) {
        new Counter(elements.item(element));
    }
};
